import { Helmet } from "react-helmet";

import BreadCrumb from "../../component/BreadCrumb";

import React, { useEffect, useState } from "react";
import AxiosClient from "../../client/AxiosClient";
import {
  API_HOME_TUTION_COURSES_WITH_PAGINATION,
  API_NEW_COURSES_WITH_PAGINATION,
} from "../../ApiEndPoints";

import { useParams } from "react-router-dom";

import InfiniteScroll from "react-infinite-scroll-component";
import AllCourses from "../../sections/AllCourses";
import Loader from "../../component/Loader";
import ErrorBoundaryWrap from "../../error-boundries/ErrorBoundaryWrap";
import ErrorBoundryWrapParent from "../../error-boundries/ErrorBoundryWrapParent";
import { useRef } from "react";

export default function HomeTutionCoursePage() {
  const params = useParams();

  // now getting courses of this category
  const [courses, setCourses] = useState([]); // Data fetched from the server
  const [page, setPage] = useState(1); // Current page number
  const [hasMore, setHasMore] = useState(true); // Whether there is more data to load
  const [courseLoading, setCourseLoading] = useState(true);

  const limit = process.env.REACT_APP_PAGINATION_LIMIT || 12;

  const fetchData = async () => {
    try {
      const response = await AxiosClient.get(
        API_HOME_TUTION_COURSES_WITH_PAGINATION,
        {
          params: { page: page, limit: limit },
        }
      );

      const newItems = response.data.data.items; // Assuming API returns { items: [], total: number }
      const total = response.data.data.total;

      // Append new items to the existing list
      setCourses((prevItems) => [...prevItems, ...newItems]);

      // Increment page
      if (newItems.length > 0) {
        setPage((prevPage) => prevPage + 1);
      }

      // Check if there are more items to load
      if (courses.length >= total) {
        setHasMore(false);
      }

      setCourseLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
    }
  };

  const hasFetchedRef = useRef(false);

  useEffect(() => {
    // preventing useref to running again
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;

    setCourseLoading(true);
    fetchData();
    setPage(1);
    setCourses([]);
  }, [params.slug]);

  return (
    <main>
      <Helmet>
        <title>Home Tuition Courses | {process.env.REACT_APP_NAME}</title>
      </Helmet>

      <ErrorBoundryWrapParent>
        <BreadCrumb
          title={"Home Tuition Courses"}
          desc={`Browse our extensive range of carefully designed coureses to enhance your legal knowledge and skills for a successful career in the legal field`}
        />
      </ErrorBoundryWrapParent>

      <section>
        <div className="container">
          {!courseLoading && (
            <InfiniteScroll
              className="inifit-scroll__wrap"
              dataLength={courses.length} // This is important to track the length of the list
              next={fetchData} // Function to fetch the next batch of data
              hasMore={hasMore} // Whether more data should be loaded
              loader={
                <div className="text-center">
                  <Loader />
                </div>
              } // Loader component
              endMessage={
                <p className="text-center mt-3">
                  <b className="fw-500 bg-light p-2  border border-primary rounded-2">
                    No more course found! Check back later for more updates.
                  </b>
                </p>
              }
            >
              <AllCourses courses={courses} />
            </InfiniteScroll>
          )}

          {courseLoading && (
            <div className="text-center">
              <Loader />
            </div>
          )}
        </div>
      </section>
    </main>
  );
}
